import { put, call } from 'redux-saga/effects';
import axios from 'axios';
import { showLoader, hideLoader } from '../../../../common/Helpers/loader';
import { getSecureBaseUrl } from '../../../../../services/UrlMapperService';
import * as actionTypes from '../../actionTypes';

export function* getIpiBodyData() {
  try {
    showLoader();
    const apiResponse = yield call(getIpiDataAPI);
    if (apiResponse && apiResponse?.data && apiResponse?.data?.content && apiResponse.status === 200) {
      yield put({
        type: actionTypes.UPDATE_IMPORTANT_PLAN_INFO_SUCCESS,
        response: apiResponse?.data?.content,
      });
      hideLoader();
    }
    hideLoader();
  } catch (err) {
    console.log(err);
    hideLoader();
  }
}

export const getIpiDataAPI = () => {
  const endPoint = '/content/support/terms/products/important-plan-information/_jcr_content.raw.json';
  const apiUrl = window.location.hostname === 'localhost' ? `${getSecureBaseUrl()}${endPoint}` : endPoint;
  return axios.get(apiUrl);
};
